import {useState, useEffect} from "react";
import {useSelector, useDispatch} from "react-redux";
import {withTranslation} from "react-i18next";
import {useTranslation} from "react-i18next";
import {dataActions, profileActions} from "_actions";
import {history} from '_helpers/history'
import {
    Button,
    Modal,
    Input,
    Tabs,
    Form,
    notification,
    Select,
    Checkbox
} from 'antd';
import './dashboard.scss';
import localOrSessionStore from "_helpers/localOrSessionStore";
import variables from "_constants/variables";
import * as _ from 'lodash';
import {
    
    CaretRightOutlined,
    UsergroupAddOutlined} from '@ant-design/icons';


import viajeImg from "../../../assets/img/backDefaultStart.png";
import {Avatar} from "../../../components/avatar/Avatar";
import {xcService} from "../../../_services/xcService";


const {Option} = Select;

const {TabPane} = Tabs;


const pendo = window.pendo;

function Dashboard(props) {
    const storage = localOrSessionStore({key: variables.REMEMBER});
    const userStorage = JSON.parse(storage.getItem(variables.USER));
    const [userData, setUserData] = useState(userStorage)
    const [form] = Form.useForm();
    const [formyear] = Form.useForm();
    const {t, i18n} = useTranslation();

    const user = JSON.parse(storage.getItem(variables.USER));
    const [showModal, setShowModal] = useState((user.noName || user.name === "" || !user.name || user.name === null) ? true : false);
    const [showVideo, setShowVideo] = useState(false);
    const [nameCenter, setNameCenter] = useState(null)
    const [errorCenter, setErrorCenter] = useState(false);
    const [idCenter, setIdCenter] = useState(null)

    const [showChange, setChange] = useState(false);
    const [changeCenter, setChangeCenter] = useState(false);
    const [name, setName] = useState("");
    const [avItems, setAvItems] = useState([]);
    const [items, setItems] = useState([]);
    const [itemsGroup, setItemsGroup] = useState([]);
    const dispatch = useDispatch();
    const [data, setData] = useState();

    const [courses, setCourses] = useState([]);
    const [showInviteUserModal, setShowInviteUserModal] = useState(false);

    var saveNameData = useSelector((state) => state.profileReducer.saveNameData);
    var getItemsData = useSelector((state) => state.profileReducer.getItemsData);
    var getAvItemsData = useSelector((state) => state.profileReducer.getAvItemsData);

    var coursesData = useSelector((state) => state.dataReducer.coursesData);
    useEffect(() => {
        if (!coursesData) getCourses();


    }, []);


    const getCourses = () => {
        dispatch(dataActions.getCourses());
    };

    useEffect(() => {
        if (coursesData) setCourses(coursesData);
    }, [coursesData]);

    useEffect(() => {

        if (user.noName || user.name === "" || !user.name || user.name === null) {
           // setShowModal(true)
        } else {
            pendo.initialize({
                visitor: {
                    id: user.uuid,
                    role: 'STUDENT'
                },

                account: {
                    id: 1,
                    NAME: "Orion",
                },
            });
        }


    }, [user])

    const isDisable = () => {
        return true;
    }


    const closeVideo = () => {
        user.firstTime = false;
        storage.setItem(variables.USER, JSON.stringify(user));
        setShowVideo(false)
        setShowModal(user.noName)

    }

    useEffect(() => {

        xcService.getToken("/v1/student/newyear").then(({data}) => {

            if (data.data && data.data.length > 0) {
            } else {
                setChange(true)
            }
        }).catch(err => setChange(false))
        getData()


    }, [])

    const getData = async () => {
        await xcService.getToken('/v1/year').then(({data}) => {
            let mYear = (+data.data)
            xcService.getToken(`/v1/questionnaire/informes/${userData.uid}`)
                .then(({data}) => {
                    return data.data.filter(data => (data.count === data.numberOfQuestions) && (String(data.year) === String(mYear)))
                })
                .then((data) =>
                    data.map(data =>
                        <a key={data.id} className={"link-informe"}
                           href={'/admin/informes/' + data.code + '?' + 'user=' + userData.uid + '&year=' + data.year}>
                            {data.name.replace('Cuestionario de ', '')}
                        </a>
                    ))
                .then(data => setData(data))
        });
    }


    useEffect(() => {
        dispatch(profileActions.getAvItems())
    }, []);

    useEffect(() => {
        if (getAvItemsData) {
            setAvItems(getAvItemsData);
            setItemsGroup(_.groupBy(getAvItemsData, "type"));
            dispatch(profileActions.getItems())
        }
    }, [getAvItemsData])


    useEffect(() => {
        if (getItemsData) {
            setItems(getItemsData)
        }
    }, [getItemsData])

    useEffect(() => {
        if (saveNameData) {


            user.name = name;
            user.noName = false;


            storage.setItem(variables.USER, JSON.stringify(user));

            window.location.reload(false);

            setName("");
            setShowModal(false);



        }
    }, [saveNameData])


    const handleOk = () => {
        setShowModal(false);
    };

    const handleCancel = () => {
        setShowModal(false);
    };

    const saveName = () => {
        dispatch(profileActions.saveName({name: name}))
    }

    function wAction() {
        if (user.noName || user.name === "" || !user.name || user.name === null) {
            setShowModal(true);
        } else {
            history.push("/admin/assessment")
        }
    }

    const onChangeName = e => {
        setName(e.target.value);
    };

    const onChange = (key) => {
    };

    const noHave = (item) => {
        if (items.filter(it => it.item.id === item).length > 0)
            return false;
        else
            return true;
    }

    const style = {
        background: "#D9D9D9",
        borderRadius: 8, padding: '8px 0', width: 84, height: 84
    };


    const onFinishInvite = (values) => {
        xcService.postToken('/v1/student/invite', values).then(({data}) => {

            setShowInviteUserModal(false);
            form.resetFields();
            notification["success"]({
                message: t("invita.enviada"),
                description:
                    t("invita.subenviada"),
            });
        });


    };

    const onFinishInviteFailed = (errorInfo) => {
        setShowInviteUserModal(false);
    };


    const handleOkChange = () => {
        // setChange(false);
    };

    const handleCancelChange = () => {
        //  setChange(false);
    };

    const onChangeYear = (values) => {
        values.center_id = idCenter;


        xcService.putToken("/v1/student/newyear", values).then(data => {
            setChange(false)
            notification["success"]({
                message: t("home.yearchange"),

            });
            window.location.reload(false);
        })


    }

    const onChangeCenter = (e) => {
        setChangeCenter(e.target.checked)
    };


    const changeCenterCode = (e) => {

        if (e.target.value.length > 4) {
            setNameCenter(null)
            setErrorCenter(false);
            xcService.get("/v1/check/center/" + e.target.value)
                .then(({data}) => {
                    setNameCenter(data.data)


                    if (data.code === "3000") {
                        // El cenro no existe

                        setErrorCenter(true);
                    } else {
                        setIdCenter(data.data.id);
                    }
                })
        } else {
            setErrorCenter(false);
            setNameCenter(null)
        }
    }

    return (
        <div className={"container boxed boxed--dashboard"}>
            {showChange &&
                <Modal className={"modalName modalYear"} title={t("home.cambioy")} heigth={990} width={750}
                       visible={showChange}
                       onOk={handleOkChange} onCancel={handleCancelChange}>
                    <div className={"diNombre"} s>
                        <div className={"titleNombre"}>{t("home.nuevoyear")}</div>
                        <Form className="authForm allHeightMobile" form={formyear}
                              onFinish={onChangeYear}
                              name="basic"
                              layout="vertical"
                              labelCol={{span: 24}}
                              wrapperCol={{span: 24}}
                              initialValues={{remember: true}}
                              autoComplete="off"
                        >
                            <Form.Item
                                label={t("registro.curso")}
                                name="course_id"
                                rules={[{
                                    required: true, message: t("mandatory"),
                                },]}
                            >
                                <Select
                                    placeholder={t("registro.courseplace")}
                                    showSearch={true}
                                    defaultActiveFirstOption={true}
                                    filterOption={false}
                                    notFoundContent={null}
                                >
                                    {courses.map((d) => {
                                        return (<Option value={d.id} key={d.id}>
                                            {d.name}
                                        </Option>);
                                    })}
                                </Select>
                            </Form.Item>
                            <Form.Item
                                name="group"
                                label={t("registro.grupo")}
                                hasFeedback
                                rules={[
                                    {required: true, message: t("mandatory")},
                                    ({getFieldValue}) => ({
                                        validator(_, value) {
                                            var DNI_REGEX = /^([A-Z])$/;
                                            value = value.toUpperCase()
                                            value = value.toUpperCase().replace(/\s/, '');
                                            if (value.match(DNI_REGEX)) {

                                                return Promise.resolve();

                                            } else {
                                                return Promise.reject(new Error(t("registro.grupoperror")));
                                            }
                                        },
                                    }),

                                ]}
                            >
                                <Input onInput={e => e.target.value = e.target.value.toUpperCase()}
                                       placeholder={t("registro.grupoplace")}/>

                            </Form.Item>

                            <Form.Item
                                name="repeat"

                                valuePropName="checked"
                            >
                                <Checkbox>{t("home.repitoc")}

                                </Checkbox>
                            </Form.Item>
                            <Form.Item
                                name="changecenter"
                                onChange={onChangeCenter}
                                value={changeCenter}
                            >
                                <Checkbox>{t("cambiodecentro")}</Checkbox>
                            </Form.Item>
                            {changeCenter &&
                                <>
                                    <div className={"nose"} style={{fontWeight: 500, fontSize:14}}>{t("nocentrose")}</div>
                                    <Form.Item
                                        name="centerCode"

                                    >
                                        <Input onChange={changeCenterCode} placeholder={t("registro.codigoc")}/>

                                    </Form.Item>

                                    {nameCenter && <div className={"infoCenterData"}>
                                        <h4>{t("registercenter.nombrecentro")}</h4>
                                        <p>
                                            {nameCenter.name}<br/>
                                            {nameCenter.address}<br/>

                                        </p>
                                    </div>}</>
                            }


                            <Form.Item
                                name="acceptconoce"
                                valuePropName="checked"
                                rules={[{
                                    validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error(t("registro.mustaccept"))),
                                },]}

                            >
                                <Checkbox>
                                    <div className="customTextSmall"
                                         dangerouslySetInnerHTML={{__html: t('registro.checkConoce')}}/>
                                </Checkbox>
                            </Form.Item>
                            <Form.Item
                                name="acceptconfirma"
                                valuePropName="checked"
                                rules={[{
                                    validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error(t("registro.mustaccept"))),
                                },]}

                            >
                                <Checkbox>
                                    <div className="customTextSmall"
                                         dangerouslySetInnerHTML={{__html: t('registro.checkConfirma')}}/>
                                </Checkbox>
                            </Form.Item>
                            <Form.Item
                                name="acceptconsiente"
                                valuePropName="checked"
                                rules={[{
                                    validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error(t("registro.mustaccept"))),
                                },]}

                            >
                                <Checkbox>
                                    <div className="customTextSmall"
                                         dangerouslySetInnerHTML={{__html: t('registro.checkConsiente')}}/>
                                </Checkbox>
                            </Form.Item>

                            <Form.Item className="buttons-pre-next">


                                <Button className="primaryButton buttonSizeS btnPrimaryBlue"
                                        type="primary" htmlType="submit">
                                    {t("next")}
                                </Button>
                            </Form.Item>
                        </Form>

                    </div>
                </Modal>
            }

            <Modal className={"modalName"} title={t("home.welcomeo")} width={550} visible={showModal} onOk={handleOk}
                   onCancel={handleCancel}>
                <div className={"diNombre"}>
                    <div className={"titleNombre"}>{t("home.faltanombre")}</div>

                    <Input style={{marginTop: 13}} value={name} onChange={onChangeName}
                           placeholder={t("home.nombrepl")}/>

                    <Button type={"primary"} onClick={() => saveName()}
                            className="primaryButton buttonSizeO centerDa">{t("start")}</Button>

                </div>
            </Modal>


            {/* Se ha movido la navbar a Admin.js */}
            {/* <NavbarLogin className="menuNavAdmin"/> */}


            {showInviteUserModal &&
                <Modal className={"modalName modal-question modal-question--tutor"}
                       title={t("invitarfamilia")}
                       centered
                       visible={showInviteUserModal}
                       onCancel={() => setShowInviteUserModal(false)}
                >
                    <Form
                        form={form}
                        name="basic"
                        layout="vertical"
                        labelCol={{span: 24}}
                        wrapperCol={{span: 24}}
                        initialValues={{remember: true}}
                        autoComplete="off"
                        onFinish={onFinishInvite}
                        onFinishFailed={onFinishInviteFailed}
                    >
                        <p>{t("invita.title")}</p>

                        <Form.Item
                            label={t("registro.name")}
                            name="name" rules={[{
                            required: true, message: t("mandatory"),
                        },]}
                        >
                            <Input placeholder={t("registro.namep")}/>
                        </Form.Item>
                        <Form.Item
                            label={t("registro.surname")}
                            name="surname" rules={[{
                            required: true, message: t("mandatory"),
                        },]}
                        >
                            <Input placeholder={t("registro.surnamep")}/>
                        </Form.Item>
                        <Form.Item
                            name="email"
                            label={t("invita.mailf")}
                            rules={[{
                                type: "email", message: t("registro.emailIncorrect"),
                            }, {
                                required: true, message: t("mandatory"),
                            },]}
                        >
                            <Input placeholder={t("invita.mailf")}/>
                        </Form.Item>
                        <Form.Item
                            name="emailrep"
                            label={t("invita.confirma")}
                            rules={[{
                                type: "email", message: t("registro.emailIncorrect"),
                            }, {
                                required: true, message: t("mandatory"),
                            }, ({getFieldValue}) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('email') === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error(t("registro.emailmis")));
                                },
                            }),]}
                        >
                            <Input placeholder={t("invita.confirma")}/>
                        </Form.Item>
                        <Form.Item className="buttons-pre-next">
                            <Button type="primary" htmlType="submit">
                                {t("send")}
                            </Button>

                            <Button onClick={() => setShowInviteUserModal(false)}
                                    className="modal-question--button modal-question--button--cancel"
                                    htmlType="button">{t("tutores.informes.cancel")}</Button>
                        </Form.Item>
                    </Form>
                </Modal>
            }

            <h1 className={"title-admin"}>{t("tuespacio")}</h1>
            <div className={"containerHome"}>
                <div className={"col col--left"}>
                    <div className={"tuespacio card card--left"}>
                        <img className="espacio-img" src={viajeImg}></img>
                        <div className="goEspacio">
                            <div className={"viaje"}>
                                <strong>{t("viaje")}</strong>
                                <p className={"subviaje"}>{t("subviaje")}</p>
                            </div>
                            <Button
                                icon={<CaretRightOutlined/>}
                                onClick={() => wAction()}
                                type={"primary"}
                                className={"primaryButton btn-icon-text is--blue-to-white"}
                            >
                                {t("startqs")}
                            </Button>
                        </div>
                    </div>


                    {data &&
                        <div className={"tuespacioinformes card card--left"}>
                            <div className={"tusinformes"}>
                                <div className={"tusimformessub"}>{t("home.report")} &nbsp;&nbsp;&nbsp;<Button
                                    icon={<UsergroupAddOutlined/>}
                                    onClick={() => setShowInviteUserModal(true)}
                                    className="primaryButton btnWhiteBlue"
                                >
                                    {t('invitarfamilia')}
                                </Button></div>
                                <div className={"infoviaje"}>
                                    {data}
                                </div>
                            </div>

                        </div>
                    }
                </div>
                <div className={"col col--right"}>
                    <Avatar onChange={onChange} user={user} itemGroups={itemsGroup} wAction={wAction} noHave={noHave}/>
                </div>

            </div>
        </div>
    )
}

export default withTranslation()(Dashboard);
